/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { atom, createStore } from "jotai/vanilla";
import { DEFAULT_PUFF_VALUES, DEFAULT_VALUES, LETTER_DEFAULTS } from "./common/constants";
import { getRandomId } from "./utils";
import ErrorTypes from "./error-types";

const DEFAULT_SIZE_AND_QUANTITY = {
  ...DEFAULT_VALUES,
  preset: "custom",
  id: getRandomId()
};
const DEFAULT_SIMULATION_ARTWORK = {
  ...LETTER_DEFAULTS,
  widthEdited: false,
  isSimulated: true,
  id: "simulation",
  style: null,
  height: null,
  color: null,
  quantity: 1,
  quantities: {},
  sizes: {},
  prices: {},
  enhancementNote: "",
  enhancementFeedbackSubmitted: false,
  enhancementRatingSubmitted: false,
  enhancementSatisfied: null,
  sizesAndQuantities: [DEFAULT_SIZE_AND_QUANTITY],
  enhancementTier: "full_enhancements"
};

export const jotaiStore = createStore();

export const showModalAtom = atom(false);

export const showArtworkHistoryModalAtom = atom(false);

export const variantIdAtom = atom(null);

export const productIdAtom = atom(null);

export const catalogNumberAtom = atom(null);

export const printAsIsAtom = atom(false);

export const neckLabelAtom = atom(false);

export const dtfMaxWidthAtom = atom(null);

export const dtfMaxHeightAtom = atom(null);

export const dtfMinWidthAtom = atom(null);

export const dtfMinHeightAtom = atom(null);

export const pdpTypeAtom = atom(null);

export const preCutAtom = atom(false);

export const productSlugAtom = atom("");

export const showCTAAtom = atom(false);

export const favoritesAtom = atom([]);

export const stickerAtom = atom(null);

export const currentStoreAtom = atom(null);

export const allowForceBgRemoveAtom = atom(false);

export const canvaReviewerAtom = atom(null);

export const unitPriceAtom = atom(null);

export const printingServiceNameAtom = atom(null);

export const cachedArtworkPricesAtom = atom({});

export const dtfCategoryAtom = atom(null);

export const spanglesAtom = atom([]);

export const canvaDtfEnabledStateAtom = atom(false);

export const showMultiSizeArtworkAtom = atom(false);

export const enablePreCutAtom = atom(false);

export const preCutPriceAtom = atom(0);

export const preCutEnabledAtom = atom(false);

export const preCutDurationAtom = atom(null);

export const preCutUpsellThresholdAtom = atom(0);

export const loadFromConfigAtom = atom(true);

export const artworksStateAtom = atom([]);

export const artworkHistoryAtom = atom([]);

export const artworkHistoryPaginationAtom = atom({
  page: 1
});

export const summaryAtom = atom({
  orderTotal: "0.0",
  productCartQuantity: 0
});

export const bogoPromotionDataAtom = atom({
  applicable: false
});

export const simulationAtom = atom({ ...DEFAULT_SIMULATION_ARTWORK });

export const fileToRemoveAtom = atom(null);

export const showDiscardModalAtom = atom(false);

export const discardedAtom = atom(null);

export const fetchControllerAtom = atom(null);

export const useDefaultValuesAtom = atom(false);

export const showFilesErrorAtom = atom(false);

export const replaceArtworkAtom = atom(false);

export const errorTypesAtom = atom(ErrorTypes);

export const isRetryingAtom = atom(false);

export const allRetryFailedAtom = atom(false);

export const localeAtom = atom("en-US");

export const experimentsAtom = atom({});

export const minStickerQuantityAtom = atom(10);

export const userTypeAtom = atom("guest_user");

export const bogoEligibilityAtom = atom({ visible: false, reason: null });

export const bogoMaxDimensionLabelAtom = atom('12"x12"');

export const promotionResolutionAtom = atom({ winner: "none" });

export const transferPdpBackButtonDetectionAtom = atom(false);

export const spangleConfigAtom = atom({
  spangleAlgorithms: [],
  isSpangle: false,
  spangleColors: []
});

export const sizeErrorTypesAtom = atom([
  ErrorTypes.INVALID_WIDTH.toString(),
  ErrorTypes.INVALID_HEIGHT.toString(),
  ErrorTypes.NEGATIVE_VALUES.toString(),
  ErrorTypes.MIN_PRINT_SIZE.toString(),
  ErrorTypes.MAX_PRINT_SIZE.toString(),
  ErrorTypes.UPSCALE_THRESHOLD_EXCEEDED.toString()
]);

export const isMobileAtom = atom(false);

export const enableMobileFooterCTAAtom = atom(false);

export const dtfChannelUuidAtom = atom(null);

export const isEnhancementLoadingAtom = atom(false);

export const actionCableOptionsAtom = atom({});

export const actionCableConnectedAtom = atom(false);

export const stickerQrScannedAtom = atom(false);

export const cableAtom = atom(null);

export const businessLineAtom = atom(null);

export const isPuffAtom = atom(false);

export const puffAtom = atom({ ...DEFAULT_PUFF_VALUES });

export const isProColorAtom = atom(false);

export const isStickerAtom = atom(false);

export const isDieCutStickerAtom = atom(false);

export const isStickerSampleAtom = atom(false);

export const isJiffyMadeAtom = atom(false);

export const printReadyInfoConfigAtom = atom({
  show: false,
  expanded: false
});

export const loadingAtom = atom({
  removeBg: false
});

export const isJerseyNumbersAtom = atom(false);

export const isLettersAtom = atom(false);

export const letterPreviewMessagesAtom = atom({});

export const artworkBackgroundAtom = atom("transparent");

export const backgroundTypeAtom = atom("checkered");

export const stickersStyleOptionsAtom = atom(false);

export const letterPreviewLoadingAtom = atom(false);

export const isGoldFoilAtom = atom(false);

export const forcePdpTransfersRedrawAtom = atom(false);

export const pinBasedRedrawEnabledAtom = atom(false);

export const pinBasedRedrawEscapedAtom = atom(false);

export const enableRedrawAtom = atom(false);

export const isPricingLoadingAtom = atom(false);

export const enhancementNoteAtom = atom("");

export const puffMaxImageCountAtom = atom(1);

export const previewCanvasSizeAtom = atom({ width: 0, height: 0 });

export const gangSheetBuilderAtom = atom(null);

export const showGangSheetBuilderAtom = atom(false);

export const generatedGangSheetsAtom = atom([]);

export const gangSheetBuilderShopIdAtom = atom(null);

export const showGangSheetBuilderFeatureAtom = atom(false);

export const isGangSheetBuilderAtom = atom(false);

export const gangSheetBuilderVariantsAtom = atom([]);

export const gangSheetBuilderSettingsAtom = atom({});

export const gangSheetBuilderSizesAtom = atom([]);

export const isDtfSheetAtom = atom(false);

export const gangSheetBulkPriceAtom = atom({});

export const storeCreditInfoAtom = atom({});

export const presetMockupColorAtom = atom(["#E1E1E1"]);

export const gangSheetBuilderCarouselsAtom = atom({});

export const updatePricingAbortSignalAtom = atom(null);

export const preloadedDesignIdAtom = atom(null);

export const reorderEnabledAtom = atom(false);

export const validateArtworkStartTimeAtom = atom({});

export const validateArtworkStartEventIntervalIDAtom = atom({});

export const paidExpertEditAddonEnabledAtom = atom(false);

export const gangSheetCatalogNumbersAtom = atom([]);

export const customerReviewOnRedrawsAtom = atom(false);

export const customerReviewOnTransferRedrawsAtom = atom(false);

export const klaviyoSmsTransactionalSubscribedAtom = atom(false);

export const smsTransactionalSubscriptionPdpEnabledAtom = atom(false);

export const transferPdpInactivityDetectionAtom = atom(false);

export const smsTransactionalPhoneAtom = atom("");

export const smsTransactionalSubscribeButtonTextAtom = atom("Subscribe");

export const messagingConsentsAtom = atom({ smsTransactional: true });

export const blankItemsCountAtom = atom(0);

export const transfersInCartCountAtom = atom(0);

export const isNewToTransfersAtom = atom(null);

export const showPinningModalAtom = atom(false);

export const pinningArtworkIndexAtom = atom(null);

export const pinningModalSessionIdAtom = atom(null);

export const pinningSessionLoadingAtom = atom(false);

export const pendingInitialMessageAtom = atom(null);

export const pendingPinningInvalidationAtom = atom(null);

export const lastConfirmedConfigSectionAtom = atom(null);
